export interface SearchPatientPayload {
  filters: QuickFilter[];
}

export interface GetSearchPatientFiltersPayload {
  filter: string;
  tenancyId: number;
  searchText?: string;
}

export interface QuickFilter {
  id: string;
  label: string;
  type: SearchFilterType;
  value?: string; // value of search text
  filterKey?: string;
}

export type FiltersConfig = {
  label: string;
  type: SearchFilterType;
};

export type FilterConfigsMap = Record<string, FiltersConfig>;
export enum SearchFilterType {
  NO_SELECTION = 'no-selection',
  SINGLE_SELECTION = 'single-selection',
  SEARCH_AND_SINGLE_SELECT = 'single-select-and-search',
  MULTI_SELECTION = 'multi-selection',
  SEARCH_AND_MULTI_SELECT = 'multi-select-and-search',
}

export enum PatientSearchFilters {
  SpecificPatient = 'Search by name or MRN',
  MyPainHealthSpecificPatient = "I'm looking for a specific patient",
  MyPainHealthNotInvited = 'I want to see patients suitable for the mypainhealth app (not invited)',
  MyPainHealthNotCompletedOnboarding = 'I want to see patients suitable for the mypainhealth app (not completed onboarding)',
  MyPainHealthCompletedOnboarding = 'I want to see patients suitable for the mypainhealth app (completed onboarding)',
  MyPainHealthReadyForReview = 'I want to see patients ready for a review',
  MyPainHealthOpenSafetyAlerts = 'I want to see patients with open safety alerts',
  DischargeNextDay = 'Patients discharging in the next day',
  AgeFilter = 'Patients with this age',
  TagsOrReviewTriggers = 'Patients with this tag or review trigger',
  SpecificUnit = 'Specific service(s)',
  AdmissionStatus = 'Patients by admission status',
  SpecificHospital = 'Specific hospital(s)',
  OpenTasks = 'Patients with open tasks',
  TasksDueToday = 'Patients with tasks due today',
  AssignedToMe = 'Patients assigned to me',
  AssignedToMyTeam = 'Patients assigned to my team',
  ParticularMedicines = 'Patients on following medicine(s)',
  ParticularPathology = 'Specific pathology test(s) / observation(s)',
  MedicinesAndPathology = 'Patients with a specific medicine and pathology result combination',
  IndigenousStatus = 'Patients that identify as Aboriginal or Torres Strait Islander',
  ParticularDrugAllergy = 'Patients with a specific drug allergy',
  ResidentialNursingHome = 'Patients with a Aged Care Facility as a residence',
}

export interface UserSavedSearchFilters {
  tenancyId: number;
  data: SavedSearchFilter[];
}

export interface SavedSearchFilter {
  id: string;
  text: string;
  pinned: boolean;
}

export interface SaveSearchFilterPayload {
  tenancyId: number;
  filterText: string;
}
